import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M225-185h135v-215q0-17 12-28t28-12h160q17 0 28 12t12 28v215h135v-383L480-759 225-568v383Zm-79 0v-383q0-18 8-35t23-28l255-192q21-16 48-16t48 16l255 192q15 11 23 28 9 17 9 35v383q0 33-23 56-24 23-57 23H566q-16 0-28-11t-11-28v-222h-94v222q0 16-11 28t-28 11H225q-33 0-56-23t-23-56Zm334-287Z"/>',
  f: '<path d="M146-185v-383q0-19 8-35 8-17 23-28l255-192q21-16 48-16t48 16l255 192q15 11 23 28 9 16 9 35v383q0 33-24 56-23 23-56 23H603q-17 0-28-11t-12-28v-219q0-16-11-28t-28-11h-88q-16 0-28 11t-11 28v219q0 16-12 28t-28 11H225q-33 0-56-23t-23-56Z"/>',
};

export default data;
